import classNames from 'classnames';
import { ModuleLoad } from 'layout/module-load/module-load.js';
import * as React from 'react';
import { IModuleConfig } from 'redux-state/layout/types.modules';
import { ModulePropsCore } from 'redux-state/layout/types.slots.js';
import { HasConfigDataUrlHook } from 'redux-state/modules-dataurl/utils';
import { ModulePath } from 'utilities/modulePath/modulePath';
import { formatUrlSlug } from 'utilities/slugify.js';

/** This allows urlSlugs to update if module config updates
 * We only want to return a string so reduce renders to only when url slug changes
 */
const GetCurrentFormatUrlSlug = (config: IModuleConfig) => {
  const { moduleConfig: module } = HasConfigDataUrlHook({ config });
  return formatUrlSlug({
    urlSlug: module.urlSlug,
    title: module.title,
    name: module.name,
  });
};

const SecondaryLargeModule = ({
  config,
  key,
  className,
  modulePath,
}: {
  config: IModuleConfig;
  key: string;
  className?: string;
  modulePath: ModulePath;
}) => {
  const dataUrlSlug = GetCurrentFormatUrlSlug(config);

  return (
    <div key={key} data-slug={dataUrlSlug} className={className} role="presentation" data-module-lookup={config.name}>
      <ModuleLoad config={config} modulePath={modulePath} />
    </div>
  );
};

export const SecondaryLargeModules = React.memo(function WrapModules({
  moduleConfigArr = [],
  modulePath,
}: ModulePropsCore) {
  return (
    <>
      {moduleConfigArr.map((config, index) => {
        const { name } = config;
        const key = `${name}${index}`;
        const isLast = index === moduleConfigArr.length - 1;
        const className = classNames({ 'u-mB-responsive': !isLast });
        return <SecondaryLargeModule config={config} key={key} className={className} modulePath={modulePath} />;
      })}
    </>
  );
});
